<template>
  <a-dropdown>
    <a-space class="space-flex">
      <UserAvatar
        :avatar-url="user.avatarUrl"
      />
      {{ user.nickname || user.name }}
    </a-space>
    <template #overlay>
      <a-menu>
        <a-menu-item>
          <a
            :href="$t('layout.header.dropdownMenu.okrConcept.url')"
            target="_blank"
          >
            {{ $t('layout.header.dropdownMenu.okrConcept.title') }}
          </a>
        </a-menu-item>
        <a-menu-item>
          <a
            :href="$t('layout.header.dropdownMenu.newFeatures.url')"
            target="_blank"
          >
            {{ $t('layout.header.dropdownMenu.newFeatures.title') }}
          </a>
        </a-menu-item>
        <a-menu-item>
          <a
            :href="$t('layout.header.dropdownMenu.manual.url')"
            target="_blank"
          >
            {{ $t('layout.header.dropdownMenu.manual.title') }}
          </a>
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>
</template>

<script>
import UserAvatar from '@/components/UserAvatar'

export default {
  components: {
    UserAvatar
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  }
}
</script>
